import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DutyRosterByShift } from '../Models/dutyrosterbyshift.model';

@Injectable({
  providedIn: 'root',
})
export class DutyRosterByShiftService {
  url = environment.Url + 'DutyRosterByShifts';
  dutyRosterItem = environment.Url + 'DutyRosterByShifts/dutyRosterItem';

  header = new HttpHeaders({
    Authorization: 'token' + localStorage.getItem('token'),
  });

  constructor(private http: HttpClient) {}

  registerDutyRosterByShift(body) {
    return this.http
      .post<DutyRosterByShift>(this.url, body)
      .pipe(catchError(this.handleError));
  }

  getDutyRosterByShifts() {
    return this.http
      .get<DutyRosterByShift[]>(this.url)
      .pipe(catchError(this.handleError));
  }
  getDutyRosterByShiftById(id) {
    return this.http.get<DutyRosterByShift>(this.url + '/' + id);
  }
  getDutyRosterItem(id) {
    return this.http.get<DutyRosterByShift>(this.dutyRosterItem + '/' + id);
  }

  updateDutyRosterByShift(id, body) {
    return this.http
      .put<DutyRosterByShift>(this.url + '/' + id, body)
      .pipe(catchError(this.handleError));
  }

  deleteDutyRosterByShift(id) {
    return this.http
      .delete<DutyRosterByShift>(this.url + '/' + id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error);
        return throwError(error.error);
      } else if (error.status == 401) {
        return throwError('invalid username or password');
      } else if (error.status == 0) {
        return throwError('network failure please try again later ');
      }
      return throwError(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
